<div>
  <img width="100%" height="auto" src="/assets/images/stats-preview-image.jpg" />
</div>